var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeForever({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.77,33.5l-8.77-6.37-8.77,6.37,3.35-10.31-8.77-6.38h10.84l3.35-10.31,3.35,10.31h10.85l-8.77,6.38,3.35,10.31ZM10.42,18.31l5.92,4.3-2.26,6.96,5.92-4.3,5.92,4.3-2.26-6.96,5.92-4.3h-7.32l-2.26-6.96-2.26,6.96h-7.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeForever);
export default __webpack_public_path__ + "static/media/free-forever.f21511790c68ba2e4e9c609f8f46fd0d.svg";
export { ForwardRef as ReactComponent };